var path = 'app/components/common/forms/templates/horizontalLabel.html';
var html = "<label ng-if=\"to.label\" for=\"{{::id}}\" class=\"{{::to.labelcss || 'col-sm-3'}} control-label\">{{to.label}} {{to.required ? \"*\" : \"\"}}</label><div class=\"{{::to.controllCss || 'col-sm-9'}}\"><formly-transclude></formly-transclude></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/components/common/forms/templates/horizontalLabel.html
// module id = 191
// module chunks = 0